import customerThunk from './../../thunk';

const route = async (dispatch) => {
  return dispatch(customerThunk);
};

export default route;
